import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  LayoutDashboard,
  SlidersHorizontal,
  Calendar,
  CalendarClock,
  CalendarCheck,
  History,
  FileText,
  Users,
  Headphones,
  ListOrdered,
  BarChart3,
  Info,
  Building2,
  MapPin,
  Wallet,
  Handshake,
  Sparkles,
  User,
  Stethoscope,
  Headset,
  Shield,
  UserCog,
  Monitor,
  Smartphone,
  ClipboardList,
  ClipboardCheck,
  Palette,
  Package,
  CreditCard,
  Compass
} from 'lucide-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { InicioRoutingModule } from './inicio-routing.module';
import { InicioComponent } from './pages/inicio/inicio.component';

@NgModule({
  declarations: [InicioComponent],
  imports: [
    CommonModule,
    InicioRoutingModule,
    SharedModule,
    LucideAngularModule.pick({
      LayoutDashboard,
      SlidersHorizontal,
      Calendar,
      CalendarClock,
      CalendarCheck,
      History,
      FileText,
      Users,
      Headphones,
      ListOrdered,
      BarChart3,
      Info,
      Building2,
      MapPin,
      Wallet,
      Handshake,
      Sparkles,
      User,
      Stethoscope,
      Headset,
      Shield,
      UserCog,
      Monitor,
      Smartphone,
      ClipboardList,
      ClipboardCheck,
      Palette,
      Package,
      CreditCard,
      Compass
    })
  ]
})
export class InicioModule {}
